<template>
  <div>
    <el-dialog v-model="dialogTableVisible" trigger="hover" title="回传马帮" width="500">
      <el-form :inline="false"  class="" style="text-align: left">
        <el-form-item  label="RII出库单号">
          <el-input style="width:200px" disabled v-model="formInline.riiNumber" ></el-input>
        </el-form-item>
        <el-form-item  label="copilot单号">
          <el-input style="width:200px" disabled v-model="formInline.trackNumber" ></el-input>
        </el-form-item>
        <el-form-item  label="物流渠道">
          <el-select
              v-model="formInline.myLogisticsChannelId"
              filterable
              allow-create
              default-first-option
              :reserve-keyword="false"
              placeholder="请选择物流渠道"
              style="width: 200px"
          >
            <el-option
                v-for="item in defaultOption"
                :key="item.name"
                :label="item.name"
                :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item  label="仓库">
          <el-select
              v-model="formInline.warehouseName"
              filterable
              allow-create
              default-first-option
              :reserve-keyword="false"
              placeholder="请选择仓库"
              style="width: 200px"
          >
            <el-option
                v-for="item in stockList"
                :key="item.warehouseName"
                :label="item.warehouseName"
                :value="item.warehousefCode"
            />
          </el-select>
        </el-form-item>


        <div class="flex flex-row-right flex-item-center">
          <div>
            <el-button style="margin: 0 auto" type="primary" @click="submit">回传马帮</el-button>
          </div>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import {
  ElDialog,
  ElForm,
  ElFormItem,
  ElInput,
  ElButton,ElSelect,ElOption
} from "element-plus";
import {getLocalStockList} from "@/../public/js/index"
import {updateBbyMbErpChannel} from "@/utils/api"
export default {
  name: "addBbyMbErp",
  components:{
    ElDialog,ElForm,ElFormItem,ElInput,ElButton,ElSelect,ElOption
  },
  data(){
    return{
      dialogTableVisible:false,
      defaultTime: new Date(),
      formInline:{
        warehouseName:"823-RII海外仓-美国线下商超RII-CA2",
        myLogisticsChannelId:"Best Buy-RIl-PAAF",
      },
      defaultOption:[
        {'name':'Best Buy-RIl-PAAF',value:'Best Buy-RIl-PAAF'}
      ],
      stockList:[
        {
          "id": 22,
          "warehousefCode": "301-DSF-RII-0078",
          "warehouseName": "823-RII海外仓-美国线下商超RII-CA2",
          "warehouseType": 2,
          "warehousRemark": ""
        }
      ]
    }
  },
  beforeMount(){
    //this.getLocalStockList()
  },
  methods:{
    getLocalStockList(){
      getLocalStockList().then(res => {
        this.stockList = res
      })
    },
    open(data){
      this.dialogTableVisible = true
      this.formInline = {...this.formInline,...data}
    },
    submit(){
      if(this.formInline.status==5){
        updateBbyMbErpChannel(this.formInline).then(res=>{
          console.log(res)
          this.dialogTableVisible = false
          this.$emit('close')
        }).catch(err=>{
          console.log(err)
        })
      }else if(this.formInline.status==6){
        console.log(this.formInline)
      }else{
        this.dialogTableVisible = false
        this.$emit('close')
      }


    }
  }
}
</script>
<style scoped>
::v-deep .el-form-item__label{
  width: 150px;
}
</style>